<template>
  <app-base-main :contentStyle="{'height': '100%'}">
    <template #base-content>
      <div class="layout mail-reply-manager">
<!--        头部筛选栏-->
        <div class="filter flex">
          <app-filter-group :isBr="false" @reset="$gjReset" @query="$gjNoticeQuery">
            <gj-radio-group
              v-model="adSwitch"
              :options="1?tabOption:[tabOption[0]]"
            ></gj-radio-group>
            <template v-if="adSwitch == 0">
              <gj-select
                key="marketOptions"
                v-model="marketId"
                width="180px"
                @change="changeMarket(marketId)"
                :clearable="false"
                type="custom"
                style="margin-left: 8px;">
                <div class="mail-option-out">
                  <el-option
                    v-for="item in marketOptions"
                    :label="item.text"
                    :value="item.id"
                    :key="item.id"
                    class="mail-option">
                    <div class="flex justify-between mail-option-item">
                      <div>
                        <div style="line-height: 18px;color: #333333;">{{item.text}}{{item.countryCode?' : '+item.countryCode:''}}</div>
                        <div style="line-height: 18px;color: #999999;">{{item.emailAddress||'未对接售后邮箱'}}</div>
                      </div>
                      <div class="colorRed" v-if="item.pendingCount > 0">{{item.pendingCount}}</div>
                    </div>
                  </el-option>
                </div>
              </gj-select>
              <template v-if="menuActive !== mailTypeEnum.QA && menuActive !== mailTypeEnum.AMAZON_EMAIL">
                <gj-select
                  v-model="mailType"
                  :options="mailTypeOption"
                  width="120px"
                  style="margin-left: 8px;"
                  placeholder="邮件类型">
                </gj-select>
                <gj-select
                  v-model="sendStatus"
                  :options="sendStatusOption"
                  width="120px"
                  style="margin-left: 8px;"
                  placeholder="发送状态">
                </gj-select>
              </template>
              <gj-select-input
                v-model="keyword"
                @keyup.enter.native="$gjNoticeQuery"
                :options="listOption"
                style="margin-left: 8px;"
                :width="['96px', '180px']">
              </gj-select-input>
            </template>
            <template v-else>
              <gj-select
                key="outSendStatusOption"
                v-model="outStatus"
                :options="outSendStatusOption"
                width="120px"
                placeholder="发送状态"
                style="margin-left: 10px;">
              </gj-select>
              <gj-input
                v-model="content"
                width="280px"
                suffix-icon="el-icon-search"
                placeholder="主题/发件人"
                style="margin-left: 10px;"
              >
              </gj-input>
            </template>
          </app-filter-group>
          <gj-tool-group
            help>
            <template v-if="$permission('ticket:edit') && adSwitch == 0" #before>
              <gj-button :loading="loading.syncMail" :disabled="!isMeaningful(afterSaleMail)" @click="syncEmail">同步</gj-button>
            </template>
          </gj-tool-group>
        </div>

        <!-- 主体-->
        <div class="content">
          <div class="content-layout" v-if="adSwitch === '0'">
          <!-- 左边-->
            <div class="mail-type"
              v-loading="loading.type"
              element-loading-spinner="not"
              element-loading-background="rgba(255, 255, 255, 0.8)">
              <div class="mail-type-list mail-type-list-scroll">
                <div class="one-level-all-item" @click="isShowSecondLevelItem = !isShowSecondLevelItem">所有邮件</div>
                <el-collapse-transition>
                  <div v-show="isShowSecondLevelItem">
                    <div class="mail-type-list-item second-level-item" :class="{'active' : menuActive === mailTypeEnum.BUYER_MAIL}" @click="changeType(mailTypeEnum.BUYER_MAIL)">
                      <gj-tooltip :content="'发送失败'" class="posa-icon" style="color: #F5222D;" v-if="pendingError.buyerEmailSendError">
                        <i class="el-icon-warning colorRed size14"></i>
                      </gj-tooltip>
                      买家消息
                      <gj-tooltip :content="'待处理数量'" style="color: #F5222D;" v-if="pendingNum.buyerEmailPendingNum>0">
                        <span>（{{pendingNum.buyerEmailPendingNum}}）</span>
                      </gj-tooltip>
                    </div>
                    <div class="mail-type-list-item second-level-item" :class="{'active' : menuActive === mailTypeEnum.NR}" @click="changeType(mailTypeEnum.NR)">
                      <gj-tooltip :content="'发送失败'" class="posa-icon" style="color: #F5222D;" v-if="pendingError.nrSendError">
                        <i class="el-icon-warning colorRed size14"></i>
                      </gj-tooltip>
                      NR
                      <gj-tooltip :content="'待处理数量'" style="color: #F5222D;" v-if="pendingNum.nrPendingNum>0">
                        <span>（{{pendingNum.nrPendingNum}}）</span>
                      </gj-tooltip>
                    </div>
                    <div class="mail-type-list-item second-level-item" :class="{'active' : menuActive === mailTypeEnum.NF}" @click="changeType(mailTypeEnum.NF)">
                      <gj-tooltip :content="'发送失败'" class="posa-icon" style="color: #F5222D;" v-if="pendingError.nfSendError">
                        <i class="el-icon-warning colorRed size14"></i>
                      </gj-tooltip>
                      NF
                      <gj-tooltip :content="'待处理数量'" style="color: #F5222D;" v-if="pendingNum.nfPendingNum>0">
                        <span>（{{pendingNum.nfPendingNum}}）</span>
                      </gj-tooltip>
                    </div>
                    <div class="mail-type-list-item second-level-item" :class="{'active' : menuActive === mailTypeEnum.QA}" @click="changeType(mailTypeEnum.QA)">
                      Q&A
                      <gj-tooltip :content="'未读数量'" style="color: #F5222D;" v-if="pendingNum.qaNotReadNum>0">
                        <span>（{{pendingNum.qaNotReadNum}}）</span>
                      </gj-tooltip>
                    </div>
                    <div class="mail-type-list-item second-level-item" :class="{'active' : menuActive === mailTypeEnum.AMAZON_EMAIL}" @click="changeType(mailTypeEnum.AMAZON_EMAIL)">
                      亚马逊邮件
                    <gj-tooltip :content="'未读数量'" style="color: #F5222D;" v-if="pendingNum.amazonEmailNotReadNum>0">
                      <span>({{pendingNum.amazonEmailNotReadNum}})</span>
                    </gj-tooltip>
                    </div>
                  </div>
                </el-collapse-transition>
                <div class="mail-type-list-item one-level-item" :class="{'active' : menuActive === mailTypeEnum.CARING_EMAIL}" @click="changeType(mailTypeEnum.CARING_EMAIL)">
                  <gj-tooltip :content="'发送失败'" class="posa-icon2" style="color: #F5222D;" v-if="pendingError.careMailSendError">
                    <i class="el-icon-warning colorRed size14"></i>
                  </gj-tooltip>
                  关怀邮件
                </div>
                <div class="mail-type-list-item one-level-item" :class="{'active' : menuActive === mailTypeEnum.CONTACT_BUYER}" @click="changeType(mailTypeEnum.CONTACT_BUYER)">
                  <gj-tooltip :content="'发送失败'" class="posa-icon2" style="color: #F5222D;" v-if="pendingError.contactBuyerSendError">
                    <i class="el-icon-warning colorRed size14"></i>
                  </gj-tooltip>
                  联系买家
                </div>
                <div class="mail-type-list-item one-level-item" :class="{'active' : menuActive === mailTypeEnum.IMPORTANT_MAIL}" @click="changeType(mailTypeEnum.IMPORTANT_MAIL)">
                  <gj-tooltip :content="'发送失败'" class="posa-icon2" style="color: #F5222D;" v-if="pendingError.markStarSendError">
                    <i class="el-icon-warning colorRed size14"></i>
                  </gj-tooltip>
                  重要邮件
                  <span v-if="pendingNum.markStarNum">（{{pendingNum.markStarNum}}）</span>
                </div>
              </div>
            </div>
<!--            右边  邮件列表及输入区-->
            <template v-if="isMeaningful(afterSaleMail)">

<!--              邮件列表-->
              <div class="mail-list"
                v-loading="loading.list"
                element-loading-spinner="not"
                element-loading-background="rgba(255, 255, 255, 0.8)">

                <div class="mail-list-filter">
                  <template v-if="menuActive !== mailTypeEnum.CARING_EMAIL && menuActive !== mailTypeEnum.CONTACT_BUYER">
                    <gj-select
                      v-model="status"
                      :options="statusOptions"
                      @change="statusChange"
                      :clearable="false"
                      size="mini"
                    ></gj-select>
                  </template>
                  <template v-else><div></div></template>
                  <span v-if="menuActive !== mailTypeEnum.BUYER_MAIL && menuActive !== mailTypeEnum.NR && menuActive !== mailTypeEnum.NF && isMeaningful(mailList) && mailList.length > 0" class="gj-pointer color666" @click="fullBidRead">全标已读</span>
                </div>

                <template v-if="isMeaningful(type) && isMeaningful(mailList) && mailList.length > 0">
                  <div class="mail-list-check-all">
                    <el-checkbox v-model="checkAll" :indeterminate="checkIndeterminate" @change="changeAll">{{`共${pagination.total}条`}}</el-checkbox>
                    <span @click="changeSort" style="cursor:pointer; margin-right: 6px;display: inherit">收件时间
                       <span style="display: flex;flex-direction: column;color: #c0c4cc">
                          <i class="el-icon-caret-top" :class="{'high_color':dateSort !== 'descending' }"></i>
                          <i class="el-icon-caret-bottom" :class="{'high_color':dateSort === 'descending' }" style="margin-top: -5px"></i>
                       </span>
                    </span>
                  </div>
                </template>

                <div class="mail-list-content">
                  <template v-if="isMeaningful(mailList) && mailList.length > 0">
                    <div class="mail-list-scroll">
                      <el-checkbox-group @change="changeHandelCheckbox" v-model="checkedMails" :class="[isMeaningful(date) ? 'scroll-height' : 'scroll-not-time-height']">
                        <template v-for="(item, index) in mailList">
                          <div @click="changeListItem(item)" class="mail-list-item" @mouseenter="hoverId = item.id" @mouseleave="hoverId = null" :key="index"
                            :class="{'mail-list-item--background': isMeaningful(emailItem) && isMeaningful(emailItem.id) && emailItem.id === item.id}">
                            <div class="mail-list-item-title">
                              <div v-if="checkedMails.length > 0 || hoverId === item.id" @click.stop="()=>{}" class="mail-list-item-title-theme">
                                <el-checkbox :label="item">
                                  <span></span>
                                </el-checkbox>
                                <div @click.stop="changeListItem(item)" class="mail-list-item-title-theme-name">{{item.emailName}}</div>
                              </div>
                              <div v-else  class="mail-list-item-title-theme">
                                <i v-if="!item.readed" class="iconfont iconyuandian colorBlue size18 posa-yuandian"></i>
                                <div class="mail-list-item-title-theme-name gj-pl24">{{item.emailName}}</div>
                              </div>
                              <template v-if="item.status === 'Pending'">
                                <div class="mail-list-item-due-time" v-if="isMeaningful(item.dueTime)">
                                  <span>
                                    <template v-if="item.dueTime > 0">
                                      <gj-tag type="text" :color="item.dueTime > 12 ? tagColors.green : tagColors.orange">
                                        剩余{{item.dueTime}}小时
                                      </gj-tag>
                                    </template>
                                    <template v-else-if="item.dueTime === 0">
                                      <gj-tag type="text" :color="tagColors.red">剩余不足1小时</gj-tag>
                                    </template>
                                    <template v-else-if="item.dueTime >= -24">
                                      <gj-tag type="text" :color="tagColors.red">超期{{Math.abs(item.dueTime)}}小时</gj-tag>
                                    </template>
                                    <template v-else>
                                      <gj-tag type="text" :color="tagColors.red">超期未回复</gj-tag>
                                    </template>
                                  </span>
                                </div>
                              </template>
                              <div class="mail-list-item-title-time">{{setDate(item.lastTime)}}</div>
                              <!-- <span class="readBtn colorBlue">标为{{!item.readed?'已':'未'}}读</span> -->
                            </div>
                            <div class="flex align-center justify-between pl24 gj-boxbor" style="margin-bottom: 3px;">
                              <div class="color999">{{ item.id }}</div>
                              <template v-if="[mailTypeEnum.BUYER_MAIL,  mailTypeEnum.NR,  mailTypeEnum.NF,  mailTypeEnum.QA,  mailTypeEnum.CONTACT_BUYER,  mailTypeEnum.CARING_EMAIL].includes(item.displayType)">
                                <gj-tag type="text" style="line-height: 18px" :color="item.status | optionColor(statusOption)">
                                  {{ item.status | optionText(statusOption) }}
                                </gj-tag>
                              </template>
                            </div>
                            <div class="mail-list-item-content gj-boxbor">
                              <div class="mail-subject" :class="{ 'pl24': item.sendStatus !== 0 }">
                                <gj-tooltip :content="'发送失败'" style="color: #F5222D;" class="gj-mr8" v-if="item.sendStatus === 0">
                                  <i class="el-icon-warning colorRed fontsize_14"></i>
                                </gj-tooltip>
                                {{ item.subject }}
                              </div>
                              <gj-tooltip :content="item.isStar ? `取消标为重要邮件`:`标为重要邮件`">
                                <img v-if="!item.isStar" @click.stop="setStarMark([item], 1)" src="../../../../assets/images/crm/collection.png" class="gj-pointer">
                                <img v-else @click.stop="setStarMark([item], 0)" src="../../../../assets/images/crm/collection2.png" class="gj-pointer">
                              </gj-tooltip>
                            </div>
                          </div>
                        </template>
                      </el-checkbox-group>
                    </div>

                    <div class="flex align-center" style="height: 38px;width: 100%;justify-content: flex-end;">
                      <gj-pagination
                          style="height: 22px;"
                          small
                          :pager-count="5"
                          :background="false"
                          :layout="'prev, pager, next'"
                          :current-page.sync="pagination.currentPage"
                          :page-size.sync="pagination.pageSize"
                          :total="pagination.total"
                          @size-change="$gjNoticeQuery()"
                          @current-change="$gjNoticeQuery('page')"
                          @prev-click="$gjNoticeQuery('page')"
                          @next-click="$gjNoticeQuery('page')"
                      ></gj-pagination>
                    </div>
                  </template>
                  <template v-else>
                    <div class="mail-list-no-content">
                      <gj-empty></gj-empty>
                    </div>
                  </template>
                </div>
              </div>

              <div style="height: 100%;width: 1px;background-color: #eeeff0;flex: none;"></div>

              <!-- 邮件内容区-->
              <div class="mail-content">
                <template v-if="checkedMails.length > 0">
                  <div class="mail-batch-operation">
                    <template v-if="$permission('ticket:edit')">
                      <template v-if="type === mailTypeEnum.BUYER_MAIL || type === mailTypeEnum.NR || type === mailTypeEnum.NF">
                        <gj-button
                          class="color333"
                          type="text"
                          @click="batchUpdateState(mailTypeStatusEnum.TRACKING)"
                          :loading="loading.Tracking"
                          :disabled="!isMeaningful(checkedMails) || checkedMails.length === 0">
                          <div class="flex align-center">
                            <img src="../../../../assets/images/crm/tracked.png" alt="">
                            标为待跟踪
                          </div>
                        </gj-button>
                      </template>
                      <gj-button
                        class="color666"
                        v-if="type === mailTypeEnum.QA"
                        type="text"
                        :loading="loading.Pending"
                        @click="batchUpdateState(mailTypeStatusEnum.PENDING)"
                        :disabled="!isMeaningful(checkedMails) || checkedMails.length === 0">
                        <div class="flex align-center">
                          <img src="../../../../assets/images/crm/processed.png" alt="">标为待处理
                        </div>
                        </gj-button>
                      <gj-button
                        class="color333"
                        v-if="type === mailTypeEnum.BUYER_MAIL || type === mailTypeEnum.NR || type === mailTypeEnum.NF || type === mailTypeEnum.QA"
                        type="text"
                        :loading="loading.Done"
                        @click="batchUpdateState(mailTypeStatusEnum.DONE)"
                        :disabled="!isMeaningful(checkedMails) || checkedMails.length === 0">
                        <div class="flex align-center">
                          <img src="../../../../assets/images/crm/placefile.png" alt="">标为已处理
                        </div>
                      </gj-button>
                      <gj-button
                        class="color333"
                        type="text" @click="setStarMark(checkedMails, 0)">
                        <span class="flex align-center">
                          <img src="../../../../assets/images/crm/cancelsign.png" class="gj-pointer gj-mr4">
                          <span>取消标记重要邮件</span>
                        </span>
                      </gj-button>
                    </template>
                  </div>
                 
                  <div v-if="menuActive === mailTypeEnum.CARING_EMAIL" class="gj-pad10">
                    <div class="checked-radio">
                      <el-radio-group v-model="checkedRadio">
                         <el-radio :label="1">选择当前页（{{checkedMails.length}}条）</el-radio>
                         <el-radio :label="2">选择全部（{{pagination.total}}条）</el-radio>
                      </el-radio-group>

                      <gj-button @click="checkedMails = [], checkAll = false">取消选择</gj-button>
                      <gj-button type="primary" @click="resendEmail">重新发送</gj-button>
                    </div>
                  </div>
                   <div v-else class="gj-pad10">
                    已选择{{checkedMails.length}}个 <gj-button @click="checkedMails = [], checkAll = false">取消选择</gj-button>
                  </div>

                </template>
                <template v-else-if="isMeaningful(emailItem)">
                  <!-- 买家邮件 NR邮件 NF邮件 关怀邮件 联系买家                -->
                  <template v-if="emailItemType === mailTypeEnum.BUYER_MAIL || emailItemType === mailTypeEnum.NR || emailItemType === mailTypeEnum.NF || emailItemType === mailTypeEnum.CARING_EMAIL|| emailItemType === mailTypeEnum.CONTACT_BUYER">
                    <app-mail-reply-buyer-content
                      ref="mailContent"
                      :item="emailItem"
                      :marketOptions="marketOptionList"
                      :mail-type="emailItemType"
                      @closeReview="closeReview"
                      @getPendingNum="queryTicketNum"
                      @closeEmail="closeEmail"
                      @getEmailAccount="getEmailAccount()"
                      @updateFile="updateFile"
                    ></app-mail-reply-buyer-content>
                  </template>
                  <!-- QA邮件 -->
                  <template v-else-if="emailItemType === mailTypeEnum.QA">
                    <app-mail-reply-qa-content
                        :item="emailItem"
                        :mail-type="emailItemType"
                        @closeReview="closeReview"
                    ></app-mail-reply-qa-content>
                  </template>
                  <!-- 亚马逊邮件 -->
                  <template v-else-if="emailItemType === mailTypeEnum.AMAZON_EMAIL">
                    <app-mail-reply-other-content
                        :item="emailItem"
                        @closeReview="closeReview"
                        :market-id="marketId"
                        :mail-type="emailItemType"
                    ></app-mail-reply-other-content>
                  </template>
                  <!-- 关怀邮件 -->
                </template>
<!--                未选中邮件-->
                <template v-else>
                  <div class="mail-content-no-content">
                    <gj-empty text="请选择邮件"></gj-empty>
                  </div>
                </template>
              </div>
            </template>
            <!-- 未绑定邮箱-->
            <template v-else>
              <div class="mail-content no-content--background">
                <div class="no-content">
                  <gj-empty text="未绑定邮箱账号，请先绑定"></gj-empty>
                  <div><gj-button type="primary" style="margin-top: 15px" @click="$router.push({path: '/system/market'})">绑定售后邮箱</gj-button></div>
                </div>
              </div>
            </template>
          </div>
          <app-off-site-mailbox
            v-if="adSwitch == '1'"
            :content="content"
            :outStatus="outStatus"
            ref="offSiteMailbox"
            @outTicketItemUnread="outTicketItemUnread"
          ></app-off-site-mailbox>

        </div>
      </div>
    </template>
  </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin, responseMixin} from "../../../../minxins";
  import './common/mail-reply.scss';
  import AppMailReplyBuyerContent from "./content/mail-reply-buyer-content";
  import AppMailReplyQaContent from "./reply-content/mail-reply-qa-content";
  import AppMailReplyOtherContent from "./reply-content/mail-reply-other-content";
  import AppOffSiteMailbox from "./reply-off-site-mailbox/index";
  import {isMeaningful, isMeaningless} from "@/utils/common";
  import {
    batchUpdateStatus,
    getMailList,
    getMailReplyQuantity,
    syncMailMessage,
    getEmailAccountCombobox,
    getMarketCombobox,
    ticketNum,
    ticketSendStatus,
    markAllRead,
    ticketCollection,
    setTicketCollection,
    outTicketItemUnread,
    resendCareEmail
  } from "@/api/crm";
  import {
    buyerEmailOrQAOption,
    mailTypeEnum,
    mailTypeStatusEnum,
    otherEmailOption,
    mailTypeOptions
  } from "./reply-content/enum";
  import {convertToDate, convertToFullDate} from "@/utils/date.util";
  import { tagColors } from "@/components/tag/tag-colors";
  import {mapGetters} from "vuex";

  export default {
    name: "mail-reply-manager",
    components: {AppMailReplyOtherContent, AppMailReplyQaContent, AppMailReplyBuyerContent, AppOffSiteMailbox},
    mixins: [isMeaningfulMixin, queryMixin, responseMixin],
    computed: {
      ...mapGetters({
        markets: 'authMarkets'
      }),
      tabOption() {
        let arr = [
          {id: '0', text: '站内邮箱'},
          {id: '1', text: '站外邮箱'}
        ]
        if(isMeaningful(this.pendingNum.innerEmailTotalNum) && this.pendingNum.innerEmailTotalNum > 0 && this.pendingNum.innerEmailTotalNum <= 999) {
          arr[0].text = `站内邮箱（${this.pendingNum.innerEmailTotalNum}）`
        } else if(isMeaningful(this.pendingNum.innerEmailTotalNum) && this.pendingNum.innerEmailTotalNum > 999) {
          arr[0].text = `站内邮箱（999+）`
        }
        if(isMeaningful(this.outTicketItemUnreadNum) && this.outTicketItemUnreadNum <= 999 && this.outTicketItemUnreadNum > 0 ) {
          arr[1].text = `站外邮箱（${this.outTicketItemUnreadNum}）`
        }else if(isMeaningful(this.outTicketItemUnreadNum) && this.outTicketItemUnreadNum > 999) {
          arr[0].text = `站外邮箱（（999+）`
        }
        return arr
      },
      statusOptions() {
        let arr = []
        if ([mailTypeEnum.BUYER_MAIL, mailTypeEnum.NR, mailTypeEnum.NF, mailTypeEnum.IMPORTANT_MAIL].includes(this.menuActive)) {
          arr = [
            { id: '', text: '全部邮件' },
            { id: 'Pending', text: '待处理' },
            { id: 'Tracking', text: '待跟踪' },
            { id: 'Done', text: '已处理' },
            { id: 'Finished', text: '已完成' }
          ]
        } else if(this.menuActive === mailTypeEnum.QA) {
          arr =  [
            { id: '', text: '全部邮件' },
            { id: 'Pending', text: '待处理' },
            { id: 'Done', text: '已处理' }
          ]
        } else if([mailTypeEnum.CARING_EMAIL, mailTypeEnum.CONTACT_BUYER].includes(this.menuActive)) {
          arr =  [
            { id: '', text: '全部邮件' },
            { id: 1, text: '发送成功' },
            { id: 0, text: '发送失败' },
            { id: 2, text: '发送中' }
          ]
        } else if(this.menuActive === mailTypeEnum.AMAZON_EMAIL) {
          arr =  [
            { id: '', text: '全部邮件' },
            { id: 1, text: '已读' },
            { id: 0, text: '未读' }
          ]
        }
        return arr
      }
    },
    watch: {
      markets(val) {
        this.emailAccountListInit()
      }
    },
    data() {
      return {
        outTicketItemUnreadNum:'',//站外邮件未读数量
        tagColors,
        loading: {
          syncMail: false,
          type: false,
          list: false,
          Pending: false,
          Tracking: false,
          Done: false,
          Checked: false
        },
        convertToFullDate: convertToFullDate,

        adSwitch: '0', // 0 站内邮件 1 站外邮件
        // header
        marketId: '',//选中店铺
        marketOptions:[],//店铺列表
        marketOptionList: [],
        emailAccountList: [],
        mailType: null,
        mailTypeOption: mailTypeOptions.filter(item => item.id != mailTypeEnum.QA && item.id != mailTypeEnum.AMAZON_EMAIL ),
        sendStatus: '',
        sendStatusOption: [
          {id:1,text:'发送成功'},
          {id:0,text:'发送失败'},
          {id:2,text:'发送中'},
        ],
        queryKeyword: '',
        content: '',
        outStatus: '',
        outSendStatusOption: [
          {id:'',text:'全部状态'},
          { id: 'success', text: '发送成功' },
          { id: 'fail', text: '发送失败' },
        ],
        status: '',//选中状态
        selectStatus:null,//选中状态
        statusOption:[
          {id:'',text:'全部状态'},
          {id:'Pending',text:'待处理', ...tagColors.violetDark},
          {id:'Tracking',text:'待跟踪', ...tagColors.blue},
          {id:'Done',text:'已处理', ...tagColors.lightGrayDark},
          {id:'Finished',text:'已完成', ...tagColors.gray},
        ],//状态列表
        menuActive: mailTypeEnum.BUYER_MAIL,
        isShowSecondLevelItem: true,

        // content
        // --type
        afterSaleMail: true,
        type: this.$route.query.type || mailTypeEnum.BUYER_MAIL,
        mailTypeEnum: mailTypeEnum,
        typeQuantity: {
          buyerEmailPendingQuantity: null,
          buyerEmailTrackingQuantity: null,
          qaPendingQuantity: null,
          amazonEmailPendingQuantity: null,
        },
        mailTypeStatusEnum: mailTypeStatusEnum,
        active: {
          buyerEmail: [mailTypeEnum.BUYER_MAIL],
          qa: [mailTypeEnum.QA],
          otherEmail: [mailTypeEnum.AMAZON_EMAIL],
        },
        // --list
        listOption: buyerEmailOrQAOption,
        option: {
          buyerEmail: buyerEmailOrQAOption,
          nr:buyerEmailOrQAOption,
          nf:buyerEmailOrQAOption,
          qa: buyerEmailOrQAOption,
          otherEmail: otherEmailOption,
        },
        keyword: {
          key: 'emailName',
          value: null,
        },
        date: null,
        mailList: [],
        emailItem: null,
        emailItemType:'',
        dateSort: 'descending',
        hoverId: null,
        checkedMails: [],
        checkAll: false,
        checkIndeterminate: false,
        pendingNum:{},
        pendingError: {},
        userEmail:'全部邮件',//当前选中店铺绑定的邮件
        isUpdateQuery: false,
        pageQuery: null,
        checkedRadio: 1,
      }
    },
    created() {
      this.dealRouteQuery()
      this.getEmailAccount();
      let mailType = this.$route.query.mailType
      if(isMeaningful(mailType)) {
        this.adSwitch = '0'
        this.changeType(mailType)
      }
    },
    activated(){
      this.dealRouteQuery()
      let mailType = this.$route.query.mailType
      if(isMeaningful(mailType) && this.isUpdateQuery) {
        this.adSwitch = '0'
        this.changeType(mailType)
      }else {
        this.queryTicketSendStatus();
        this.$gjNoticeQuery();
      }
      this.getEmailAccount();
      this.outTicketItemUnread();
      if(this.$refs.mailContent&&(this.emailItemType === 'BuyerEmail'||this.emailItemType === 'NR'||this.emailItemType === 'NF')){
        this.$refs.mailContent.getDetailRelated(this.emailItem);
      }
    },
    mounted() {
      this.outTicketItemUnread()
      this.queryTicketNum();
      this.queryTicketSendStatus();
    },
    methods: {
      dealRouteQuery() {
        if(isMeaningless(this.pageQuery)) {
          this.pageQuery = this.$route.query
          this.isUpdateQuery = true
        } else if(isMeaningful(this.pageQuery) && isMeaningful(this.$route.query) && this.contrastQuery()) {
          this.isUpdateQuery = true
          this.pageQuery = this.$route.query
        } else {
          this.isUpdateQuery = false
        }
      },
      contrastQuery() {
        if(isMeaningful(this.pageQuery)) {
          for(let key in this.pageQuery) {
            if(this.pageQuery[key] != this.$route.query[key]) {
              return true
            }
          }
        } else {
          return false
        }
      },
      outTicketItemUnread() {
        outTicketItemUnread().then((res)=>{
          this.outTicketItemUnreadNum = res
        })
      },
       // 改变
      adSwitchChange(type) {
        this.adSwitch = type
      },
      updateFile(val){
        this.emailItem.uploadAttFiles=val;
      },
      //关闭当前打开的邮件
      closeEmail(){
        this.emailItem=null;
      },
      //review详情页关闭回调
      closeReview(type){
        if(type){
          this.closeEmail()
        }
        this.queryTicketSendStatus()
        this.$gjQuery();
      },
      //获取所有邮箱列表
      getEmailAccount(){
      //获取所有邮箱列表 出入子组件
        getEmailAccountCombobox().then(res=>{
          //邮箱--对应店铺列表
          this.emailAccountList = res || []
          // 授权邮箱初始化
          this.emailAccountListInit()
        })
        //下拉获取所有邮箱列表
        getMarketCombobox().then(res=>{
          let marketOptions = res || []
          marketOptions.forEach(item => {
            item.id = item.marketId
            item.text = item.marketName
            item.selected = null
          })
          //邮箱--对应店铺列表
          marketOptions.unshift({id:'',text:'全部店铺',emailAddress:'全部邮箱',selected:null,countryCode:''});
          this.marketOptions = marketOptions
        })
      },
      emailAccountListInit() {
        let marketOptionList = this.markets.map(m => {
          let r =  this.emailAccountList.filter(r => r.marketId === m.id)[0];
          if (r) {
            return {
              mailId:r.id,
              ...r,
              ...m,
              status:r.status
            }
          }else {
            return m
          }
        });
        this.marketOptionList = marketOptionList
      },
      // 获取不同类型待处理或未读的邮件数量
      queryTicketNum() {
        const params = {
          marketId: this.marketId
        };
        ticketNum(params).then(res=>{
          this.pendingNum = res;
        })
      },
      // 获取不同类型邮件中是否存在发送失败邮件
      queryTicketSendStatus() {
        const params = {
          marketId: this.marketId
        };
        ticketSendStatus(params).then(res=>{
          this.pendingError = res;
        })
      },
      // 切换类型
      statusChange() {
        this.$gjNoticeQuery()
      },
      // 全标已读
      fullBidRead() {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: "温馨提示",
            content: `请确定是否全标已读！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {displayType: this.type}
              markAllRead(params).then(res => {
                this.$gjMessage.success('操作成功');
                modal.$gjDestroy();
                this.$gjQuery();
              })
            }
          },
        });
      },
      // 设置为重要图标
      setStarMark(rows, type) {
        this.loading.Checked = true
        let arr = rows.filter(item => item.isStar == !type)
        if(arr.length > 0) {
          let params = {
            ticketIds: arr.map(item => item.id),
            type: type
          }
          setTicketCollection(params).then(res => {
            this.$gjMessage.success(res.data);
            this.$gjQuery();
            if(isMeaningful(this.emailItem) && rows.map(item => item.id).includes(this.emailItem.id)) {
              this.emailItem.isStar = type
            }
          }).complete(res => { this.loading.Checked = false })
        }else {
          this.$gjMessage.warning(`请选择${type?'未标为':''}重要邮件`)
          this.loading.Checked = false
        }
      },
      setDate(date){
        if(date){
          if(new Date().getFullYear()>new Date(date).getFullYear()){
            return convertToFullDate(new Date(date), 'yyyy-MM-dd')
          }else {
            return convertToFullDate(new Date(date), 'MM-dd')
          }
        }else {
          return '-'
        }
      },
      buildMailReplyQuantity(key) {
        if (isMeaningful(this.typeQuantity[key]) && this.typeQuantity[key] > 0) {
          return `${this.typeQuantity[key]}`;
        }
        return '';
      },
      syncEmail() {
        this.loading.syncMail = true;
        syncMailMessage(this.marketId);
        setTimeout(() => {
          this.loading.syncMail = false;
          this.$gjMessage.info('站点已经在后台启动邮件同步任务，请等三分钟后再查看邮件数据！');
        }, 300)
      },
      loadTypeQuantity() {
        this.loading.type = true;
        getMailReplyQuantity(this.marketId)
          .then((data) => {
            if (isMeaningful(data)) {
              this.typeQuantity.buyerEmailPendingQuantity = data.buyerEmailPendingQuantity;
              this.typeQuantity.qaPendingQuantity = data.qaPendingQuantity;
              this.typeQuantity.amazonEmailPendingQuantity = data.amazonEmailPendingQuantity;
              this.typeQuantity.buyerEmailTrackingQuantity = data.buyerEmailTrackingQuantity;
              this.afterSaleMail = data.email;
            } else {
              this.typeQuantity.buyerEmailPendingQuantity = null;
              this.typeQuantity.qaPendingQuantity = null;
              this.typeQuantity.amazonEmailPendingQuantity = null;
              this.typeQuantity.buyerEmailTrackingQuantity = null;
              this.afterSaleMail = null;
            }
          }).complete(() => this.loading.type = false);
      },
      //切换店铺
      changeMarket(marketId){
        this.afterSaleMail = this.marketOptions.find(r => r.id === marketId).emailAddress;
        this.userEmail = this.marketOptions.find(r => r.id === marketId).emailAddress || '未对接售后邮箱';
        this.changeTypeItemNew()
      },
      //切换查看邮件类型
      changeType(type){
        // if(isMeaningless(this.afterSaleMail)){
        //   return
        // }
        //设置邮件类型
        this.menuActive = type;
        this.type = type;
        this.status = '';
        this.mailType = '';
        this.sendStatus = this.isUpdateQuery && this.pageQuery.mailType == this.type && isMeaningful(this.pageQuery.sendStatus) ? +this.pageQuery.sendStatus : '',
        this.keyword = {
          key: this.isUpdateQuery && this.pageQuery.mailType == this.type? this.pageQuery.key || 'emailName' : 'emailName',
          value: this.isUpdateQuery && this.pageQuery.mailType == this.type ?this.pageQuery.value ||  null : '',
        }
        //根据不通邮件类型，设置不同输入框下拉选项
        if (this.type === mailTypeEnum.BUYER_MAIL) {
          this.listOption = this.option.buyerEmail;
        }else if (this.type === mailTypeEnum.NR) {
          this.listOption = this.option.nr;
        }else if (this.type === mailTypeEnum.NF) {
          this.listOption = this.option.nf;
        } else if (this.type === mailTypeEnum.QA) {
          this.listOption = this.option.qa;
        } else if (this.type === mailTypeEnum.AMAZON_EMAIL) {
          this.listOption = this.option.otherEmail;
        } else {
          this.listOption = this.option.buyerEmail;
        }
        this.changeTypeItemNew()
      },
      changeTypeItemNew(){
        this.queryTicketSendStatus()
        //重置已选中邮件
        this.closeEmail()
        this.$gjNoticeQuery();
      },
      clickTime() {
        this.$refs.mailDate.pickerFocus();
      },
      clearTime() {
        this.date = null;
        this.$gjQuery();
      },
      changeSort() {
        this.dateSort = this.dateSort === 'descending' ? 'ascending' : 'descending';
        this.$gjQuery();
      },
      //点击具体邮件
      changeListItem(item) {
        if(this.checkedMails.length > 0) {
          let index = this.checkedMails.findIndex(items=> items.id === item.id)
          if(index != -1) {
            this.checkedMails.splice(index, 1)
          }else {
            this.checkedMails.push(item)
          }
          this.checkAll = this.checkedMails.length === this.mailList.length
          this.checkIndeterminate = (this.checkedMails.length < this.mailList.length) && this.checkedMails.length > 0
        } else{
          if(!item.readed && ((item.displayType === mailTypeEnum.QA && this.pendingNum.qaNotReadNum) || (item.displayType === mailTypeEnum.AMAZON_EMAIL && this.pendingNum.amazonEmailNotReadNum))){
            this.queryTicketNum();
          }
          //取消未读标记
          item.readed = true;
          this.emailItem = item;
          this.emailItemType = item.displayType;
        }
      },
      changeAll(event) {
        this.checkAll = event;
        this.checkIndeterminate = false;
        this.checkedMails = [];
        if (event) {
          this.checkedMails = [].concat(this.mailList)
        }
      },
      changeHandelCheckbox() {
        this.checkAll = this.mailList && this.mailList.length > 0 && this.mailList.every(v => this.checkedMails.map(item => item.id).indexOf(v.id) !== -1);
        this.checkIndeterminate = !this.checkAll && this.checkedMails.length > 0;
      },
      //批量标注待跟踪 已处理状态
      batchUpdateState(status) {
        this.loading.list = true;
        this.loading[status] = true;
        //获取已选中的邮件的状态数组
        let passArr = []
        if(status === mailTypeStatusEnum.TRACKING) {
          passArr = this.checkedMails.filter(item => item.status === mailTypeStatusEnum.PENDING)
        } else if(status === mailTypeStatusEnum.PENDING){
          passArr = this.checkedMails.filter(item => item.status === mailTypeStatusEnum.Done)
        } else if(status === mailTypeStatusEnum.DONE){
          passArr = this.checkedMails.filter(item => item.status === mailTypeStatusEnum.TRACKING || item.status === mailTypeStatusEnum.PENDING)
        }
        if(passArr.length > 0) {
           batchUpdateStatus({
            ids: passArr.map(item => item.id),
            status: status,
          }).then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('操作成功');
              if(this.$refs.mailContent){
                this.$refs.mailContent.tabClick();
              }
              //刷新邮件列表
              this.$gjQuery();
            })
          }).complete(() => {
            this.loading.list = false;
            this.loading[status] = false;
          })
        } else {
          let msg = status == mailTypeStatusEnum.TRACKING ? '请选择待处理的邮件!' : status == mailTypeStatusEnum.PENDING ? '请选择已处理的邮件!' : '请选择待跟踪/待处理的邮件!'
          this.$gjMessage.warning(msg)
          this.loading.list = false;
          this.loading[status] = false;
        }
      },
      $gjQueryInitParams() {
        if (this.adSwitch == 1) {
          this.$refs.offSiteMailbox.initParams()
          return {
            outStatus:'',
            content:'',
          }
        }
        return  {
          marketId: '',
          mailType: '',
          sendStatus: this.isUpdateQuery && this.pageQuery.mailType == this.menuActive && isMeaningful(this.pageQuery.sendStatus) ? +this.pageQuery.sendStatus : '',
          keyword: {
            key: this.isUpdateQuery && this.pageQuery.mailType == this.menuActive? this.pageQuery.key || 'emailName' : 'emailName',
            value: this.isUpdateQuery && this.pageQuery.mailType == this.menuActive ? this.pageQuery.value ||  null : '',
          }
        }
      },
      //获取邮件列表
      $gjQuery() {
        // 刷新/获取邮件数量
        this.queryTicketNum();
        if(this.adSwitch == 1) {
          this.$refs.offSiteMailbox.outTicketItemList()
          return
        }
        this.loading.list = true;
        const params = {
          model: {
            displayType: this.type,
            type: [mailTypeEnum.QA, mailTypeEnum.AMAZON_EMAIL].includes(this.type) ? '' : this.mailType,
            marketId: this.marketId,
            sendStatus: [mailTypeEnum.QA, mailTypeEnum.AMAZON_EMAIL].includes(this.type) ? '' : this.sendStatus
          },
          ...this.queryPagination,
          sort: 'lastTime',
          order: this.dateSort,
        };
        params.model[this.keyword.key] = this.keyword.value;
        if([mailTypeEnum.BUYER_MAIL, mailTypeEnum.NR, mailTypeEnum.NF, mailTypeEnum.QA, mailTypeEnum.IMPORTANT_MAIL].includes(this.type)) {
          params.model.status = this.status
        } else if(this.type === mailTypeEnum.AMAZON_EMAIL) {
          params.model.readed = this.status === 1 ? true : this.status === 0 ? false : null
        }
        if(this.type === mailTypeEnum.IMPORTANT_MAIL) {
          params.model.displayType = ''
          ticketCollection(params)
            .then((data) => {
              this.mailList = data.records;
              this.mailList.forEach(r=>{
                r.uploadAttFiles=[];
              })
              if(data.records.length === 0) {
                this.closeEmail()
              }else {
                // 默认打开第一封邮件
                if(isMeaningful(this.emailItem)) {
                  let index = this.mailList.findIndex(item => this.emailItem.id === item.id)
                  if(index === -1) {
                    this.changeListItem(this.mailList[0])
                  }else {
                     this.changeListItem(this.mailList[index])
                  }
                } else {
                  this.changeListItem(this.mailList[0])
                }
              }
              this.pagination = this.getPagination(data);
              this.checkedMails = [];
              this.checkAll = false;
              this.checkIndeterminate = false;
            }).complete(() => this.loading.list = false)
        } else {
          getMailList(params)
            .then((data) => {
              this.mailList = data.records;
              this.mailList.forEach(r=>{
                r.uploadAttFiles=[];
              })
              if(data.records.length === 0) {
                this.closeEmail()
              } else {
                // 默认打开第一封邮件
                if(isMeaningful(this.emailItem)) {
                  let index = this.mailList.findIndex(item => this.emailItem.id === item.id)
                  if(index === -1) {
                    this.changeListItem(this.mailList[0])
                  }else {
                     this.changeListItem(this.mailList[index])
                  }
                } else {
                  this.changeListItem(this.mailList[0])
                }
              }
              this.pagination = this.getPagination(data);
              this.checkedMails = [];
              this.checkAll = false;
              this.checkIndeterminate = false;
            }).complete(() => this.loading.list = false)
        }
      },
      resendEmail() {
        const vm = this;
         const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: "确认发送",
            content: `已选择${vm.checkedRadio === 1 ? vm.checkedMails.length : vm.pagination.total}条进行重新发送，请确认？<br/>请谨慎操作，确认发送内容，避免重复发送？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              let list = [];
               if (vm.checkedRadio === 1) {
                  list = vm.checkedMails.map(v => v.id);
               }else {
                  list = []
               }
              modal.confirmLoading = true;
              resendCareEmail(list).then(res => {
                 vm.$gjMessage.success('操作成功');
                 modal.$gjDestroy();
                 vm.$gjQuery();
              }).complete(() => modal.confirmLoading = false);
           
            }
          },
        });
      }

      
    }
  }
</script>

<style scoped lang="scss">
@import '~@/assets/styles/variables.scss';
.ad-switch {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  .switch-cell {
    position: relative;
    padding: 0 12px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    // background: #EDF7FF;
    // border-radius: 2002px;
    border: 1px solid #D8DADD;
    cursor: pointer;
    color: #666;
    &:first-child {
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
    }
    &:last-child {
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
    &.active {
      z-index: 2;
      color: #1F6EEF;
      border: 1px solid #1F6EEF;
      background: #EDF7FF;
    }
  }
}
.mailbox {
  .el-button {
    margin-left: 0 !important;
  }
}
.base-main{
  height: 100%;
  box-sizing: border-box;
}
.ad-badge{
  margin-left: 5px;
  /deep/.el-badge{
    vertical-align: unset;
  }
  /deep/ .el-badge__content{
    background-color: #F5222D;
    color: #FFFFFF;
  }
}
  /deep/ .el-collapse-item__header {
    margin-left: 15px;
  }
  /deep/ .el-button{
    margin-left: 12px!important;
  }
  /deep/ .el-collapse{
    border: 0;
  }
  /deep/ .el-collapse-item__wrap{
    border: 0;
  }
  /deep/ .el-collapse-item:last-child{
    margin: 0;
  }
  /deep/ .el-alert--warning {
    border: 1px solid #F6BB90;
  }

  /deep/ .el-pagination {
    font-weight: 400;
  }

  .mail-list-filter{
    .mail-reply-input_close{
      color: #c0c4cc;
      cursor: pointer;
      display: none;
      &:hover{
        color: #999999;
      }
    }
    /deep/ .el-input{
      &:hover, &:focus{
        .mail-reply-input_close{
          display: inline-block;
        }
      }
    }
    /deep/.el-input__suffix-inner{
      display: flex;
      align-items: center;
    }
    .main-list-filter--seg {
      width: 1px;
      height: 16px;
      background-color: #ddd;
      transform: none;
      transform: none;
      position: static;
    }
    /deep/.el-input--suffix .el-input__inner{
      // padding-right: 71px;
      background: #F8F8F8;
      border: none;
    }
    /deep/.el-input-group__prepend{
      .el-input--suffix .el-input__inner{
        padding-right: 30px;
      }
    }
  }
  .mail-list-no-content{
    transform: translate(50px);
  }
  .high_color{
     color: #1F6EEF;
  }

  .posa-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    margin-top: -9px;
  }
  .posa-icon2 {
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -9px;
  }
  .posa-yuandian {
    position: absolute;
    left: 0px;
    top: 50%;
    margin-top: -9px;
  }

  //店铺下拉框css
.mail-option-out{
  width: 280px;
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 0;
  .mail-option{
    height: auto;
    padding: 0;
    &:hover{
      background-color: #EDF7FF;
    }
    .mail-option-item{
      height: 50px;
      font-size: 12px;
      padding: 6px 16px;
      box-sizing: border-box;
    }
  }
}


  //左边导航栏css
/deep/.el-menu{
  border: none;
}
  /deep/.el-menu-item{
    font-size: 12px;
    height: 32px;
    line-height: 1;
    font-weight: 400;
    font-family: PingFangSC-Regular;
    padding: 0 12px!important;
  }
 /deep/.el-menu-item:hover, .el-menu-item:focus{
   background-color: $gj-hover-color-b1;
 }
  .menu-tit{
    color: $gj-font-color-grey8;
  }
  /deep/.el-menu-item.is-active{

  }
  .mail-address{
    line-height: 34px;
    font-size: 12px;
    color: $gj-font-color-grey7;
    padding: 4px 0 0 12px;
    width: 104px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  /deep/.el-pagination__total{
    margin-right: 0;
  }
  /deep/.el-pagination{
    padding-right: 0;
    .btn-prev{
      padding: 0 5px!important;
    }
    .btn-next{
      padding: 0 5px!important;
    }
  }
.mail-type-list{
  /deep/ .is-active{
    background-color: #EDF7FF;
  }
}

/deep/ .operate-group{
  margin: 0;
}

/deep/ .checked-radio .el-radio {
      display: block;
       margin:10px 0;
}

</style>
